export const SEARCH_LOT_ASYNC = "SEARCH_LOT_ASYNC";
export const SEARCH_LOT_SUCCESS = "SEARCH_LOT_SUCCESS";
export const CREATE_LOT_ASYNC = "CREATE_LOT_ASYNC";
export const UPDATE_LOT_ASYNC = "UPDATE_LOT_ASYNC";
export const DELETE_LOT_ASYNC = "DELETE_LOT_ASYNC";
export const GET_LOT_BY_ID_ASYNC = "GET_LOT_BY_ID_ASYNC";
export const GET_LOT_BY_ID_SUCCESS = "GET_LOT_BY_ID_SUCCESS";
export const IMPORT_LOT_ASYNC = "IMPORT_LOT_ASYNC";
export const IMPORT_LOT_SUCCESS = "IMPORT_LOT_SUCCESS";
export const IMPORT_LOT_FAIL = "IMPORT_LOT_FAIL";
export const CREATE_UPDATE_LOT_ERROR = "CREATE_LOT_ERROR";
export const RESET_LOT = "RESET_LOT";
export const CREATE_UPDATE_SUCCESS = "CREATE_UPDATE_SUCCESS";
export const RESET_LOT_UPDATED = "RESET_LOT_UPDATED";
export const SELECT_ROOM_ASYNC = "SELECT_ROOM_ASYNC";
export const SELECT_ROOM_SUCCESS = "SELECT_ROOM_SUCCESS";
export const SELECT_TRADE_ASYNC = "SELECT_TRADE_ASYNC";
export const SELECT_TRADE_SUCCESS = "SELECT_TRADE_SUCCESS";
export const CHECK_HOMEOWNER_EXISTING_BY_EMAIL_ASYNC =
  "CHECK_HOMEOWNER_EXISTING_BY_EMAIL_ASYNC";
export const INVITE_HOMEOWNER_ASYNC = "INVITE_HOMEOWNER_ASYNC";
export const INVITE_HOMEOWNER_SUCCESS = "INVITE_HOMEOWNER_SUCCESS";
export const SET_OWNERSHIP_TO_LOT_ASYNC = "SET_OWNERSHIP_TO_LOT_ASYNC";
export const UPDATE_PURCHASE_DATE_TO_LOT_ASYNC =
  "UPDATE_PURCHASE_DATE_TO_LOT_ASYNC";
export const ADD_MORE_HOMEOWNER_TO_LOT_ASYNC =
  "ADD_MORE_HOMEOWNER_TO_LOT_ASYNC";
export const RESET_PRIMARY_HOMEOWNER_TO_LOT_ASYNC =
  "RESET_PRIMARY_HOMEOWNER_TO_LOT_ASYNC";
export const RESET_LOT_PROFILE = "RESET_LOT_PROFILE";
export const CHECK_TENANCY_EXISTING_BY_EMAIL_ASYNC =
  "CHECK_TENANCY_EXISTING_BY_EMAIL_ASYNC";
export const INVITE_TENANCY_ASYNC = "INVITE_TENANCY_ASYNC";
export const INVITE_TENANCY_SUCCESS = "INVITE_TENANCY_SUCCESS";
export const SET_TENANCY_TO_LOT_ASYNC = "SET_TENANCY_TO_LOT_ASYNC";
export const SET_LOT_PRIMARY_CONTACT_ASYNC = "SET_LOT_PRIMARY_CONTACT_ASYNC";
export const REMOVE_TENANCY_ASYNC = "REMOVE_TENANCY_ASYNC";

//Lot tab
export const GET_LOT_TAB_ASYNC = "GET_LOT_TAB_ASYNC";
export const GET_LOT_TAB_SUCCESS = "GET_LOT_TAB_SUCCESS";
export const SEARCH_RFS_LOT_ASYNC = "SEARCH_RFS_LOT_ASYNC";
export const SEARCH_RFS_LOT_SUCCESS = "SEARCH_RFS_LOT_SUCCESS";
export const RESET_RFS_LOT = "RESET_RFS_LOT";

//Homeowner Lot
export const GET_HOMEOWNER_LOT_LIST_ASYNC = "GET_HOMEOWNER_LOT_LIST_ASYNC";
export const GET_HOMEOWNER_LOT_LIST_SUCCESS = "GET_HOMEOWNER_LOT_LIST_SUCCESS";
export const GET_HOMEOWNER_LOT_DETAIL_ASYNC = "GET_HOMEOWNER_LOT_DETAIL_ASYNC";
export const SEARCH_HOMEOWNER_RFS_LOT_ASYNC = "SEARCH_HOMEOWNER_RFS_LOT_ASYNC";
export const CHECK_HOMEOWNER_LOT_RFS_ASYNC = "CHECK_HOMEOWNER_LOT_RFS_ASYNC";
export const GET_HOMEOWNER_LOT_DOCUMENT_ASYNC =
  "GET_HOMEOWNER_LOT_DOCUMENT_ASYNC";
export const GET_HOMEOWNER_LOT_DOCUMENT_SUCCESS =
  "GET_HOMEOWNER_LOT_DOCUMENT_SUCCESS";
export const SETUP_HOMEOWNER_LOT_DOCUMENT_AWS_ASYNC =
  "SETUP_HOMEOWNER_LOT_DOCUMENT_AWS_ASYNC";

//Lot Documents
export const GET_LOT_DOCUMENT_ASYNC = "GET_LOT_DOCUMENT_ASYNC";
export const GET_LOT_DOCUMENT_SUCCESS = "GET_LOT_DOCUMENT_SUCCESS";
export const SETUP_LOT_DOCUMENT_AWS_ASYNC = "SETUP_LOT_DOCUMENT_AWS_ASYNC";
export const SETUP_LOT_DOCUMENT_AWS_SUCCESS = "SETUP_LOT_DOCUMENT_AWS_SUCCESS";
export const UPLOAD_LOT_DOCUMENT_TO_S3_ASYNC =
  "UPLOAD_LOT_DOCUMENT_TO_S3_ASYNC";
export const UPLOAD_LOT_DOCUMENT_TO_SERVER_ASYNC =
  "UPLOAD_LOT_DOCUMENT_TO_SERVER_ASYNC";
export const UPLOAD_LOT_DOCUMENT_TO_SERVER_SUCCESS =
  "UPLOAD_LOT_DOCUMENT_TO_SERVER_SUCCESS";
export const REMOVE_LOT_DOCUMENT_ASYNC = "REMOVE_LOT_DOCUMENT_ASYNC";
export const REMOVE_LOT_DOCUMENT_SUCCESS = "REMOVE_LOT_DOCUMENT_SUCCESS";
export const DOWNLOAD_LOT_DOCUMENT_ASYNC = "DOWNLOAD_LOT_DOCUMENT_ASYNC";
export const RESET_LOT_DOCUMENT = "RESET_LOT_DOCUMENT";

//Lot notes
export const GET_LOT_NOTES_ASYNC = "GET_LOT_NOTES_ASYNC";
export const GET_LOT_NOTES_SUCCESS = "GET_LOT_NOTES_SUCCESS";
export const GET_LOT_NOTES_FAIL = "GET_LOT_NOTES_FAIL";

export const ADD_LOT_NOTE_ASYNC = "ADD_LOT_NOTE_ASYNC";
export const ADD_LOT_NOTE_SUCCESS = "ADD_LOT_NOTE_SUCCESS";
export const ADD_LOT_NOTE_FAIL = "ADD_LOT_NOTE_FAIL";

export const EDIT_LOT_NOTE_ASYNC = "EDIT_LOT_NOTE_ASYNC";
export const EDIT_LOT_NOTE_SUCCESS = "EDIT_LOT_NOTE_SUCCESS";
export const EDIT_LOT_NOTE_FAIL = "EDIT_LOT_NOTE_FAIL";

export const DELETE_LOT_NOTE_ASYNC = "DELETE_LOT_NOTE_ASYNC";

//Lot location
export const GET_LOT_LOCATIONS_ASYNC = "GET_LOT_LOCATIONS_ASYNC";
export const GET_LOT_LOCATIONS_SUCCESS = "GET_LOT_LOCATIONS_SUCCESS";
export const GET_LOT_LOCATIONS_FAIL = "GET_LOT_LOCATIONS_FAIL";
export const RESET_LOT_LOCATIONS = "RESET_LOT_LOCATIONS";
export const GET_HOMEOWNER_LOT_LOCATIONS_ASYNC =
  "GET_HOMEOWNER_LOT_LOCATIONS_ASYNC";
export const GET_HOMEOWNER_LOT_LOCATIONS_SUCCESS =
  "GET_HOMEOWNER_LOT_LOCATIONS_SUCCESS";

//Homeowner manuals
export const GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC =
  "GET_SELECT_LIST_HOMEOWNER_LOT_ASYNC";
export const GET_SMART_APP_ASYNC = "GET_SMART_APP_ASYNC";
export const GET_ITEM_DETAIL_INVENTORY_ASYNC =
  "GET_ITEM_DETAIL_INVENTORY_ASYNC";
export const GET_HOMEOWNER_DOCUMENT_CATEGORY_ASYNC =
  "GET_HOMEOWNER_DOCUMENT_CATEGORY_ASYNC";
export const UPLOAD_DOCUMENT_BY_CATEGORY_ASYNC =
  "UPLOAD_DOCUMENT_BY_CATEGORY_ASYNC";
export const EDIT_DOCUMENT_BY_CATEGORY_ASYNC =
  "EDIT_DOCUMENT_BY_CATEGORY_ASYNC";
export const DELETE_HOMEOWNER_DOCUMENT_ASYNC =
  "DELETE_HOMEOWNER_DOCUMENT_ASYNC";

export const GET_DOCUMENT_BY_CATEGORY_ASYNC = "GET_DOCUMENT_BY_CATEGORY_ASYNC";
export const GET_HOMEOWNER_DOCUMENT_CATEGORY_SUCCESS =
  "GET_HOMEOWNER_DOCUMENT_CATEGORY_SUCCESS";
export const GET_SELECT_LIST_HOMEOWNER_LOT_SUCCESS =
  "GET_SELECT_LIST_HOMEOWNER_LOT_SUCCESS";
export const GET_LIST_HOMEOWNER_DOCUMENT_TYPE_ASYNC =
  "GET_LIST_HOMEOWNER_DOCUMENT_TYPE_ASYNC";
export const GET_LIST_HOMEOWNER_DOCUMENT_TYPE_SUCCESS =
  "GET_LIST_HOMEOWNER_DOCUMENT_TYPE_SUCCESS";
export const GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC =
  "GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_ASYNC";
export const GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS =
  "GET_HOMEOWNER_DOCUMENT_BY_DOCUMENT_TYPE_SUCCESS";
export const GET_HOMEOWNER_INVENTORY_CATEGORY_ASYNC =
  "GET_HOMEOWNER_INVENTORY_CATEGORY_ASYNC";
export const GET_INVENTORY_CATEGORY_ASYNC = "GET_INVENTORY_CATEGORY_ASYNC";
export const DELETE_INVENTORY_CATEGORY_ASYNC =
  "DELETE_INVENTORY_CATEGORY_ASYNC";
export const DELETE_INVENTORY_ITEM_HO_ASYNC = "DELETE_INVENTORY_ITEM_HO_ASYNC";
export const ADD_NEW_INVENTORY_CATEGORY = "ADD_NEW_INVENTORY_CATEGORY";
export const UPDATE_INVENTORY_CATEGORY = "UPDATE_INVENTORY_CATEGORY";
export const GET_ITEM_BY_INVENTORY_CATEGORY_ASYNC =
  "GET_ITEM_BY_INVENTORY_CATEGORY_ASYNC";
export const GET_UPLOAD_FILE_ASYNC = "GET_UPLOAD_FILE_ASYNC";
export const ADD_NEW_INVENTORY_ITEM = "ADD_NEW_INVENTORY_ITEM";
export const UPDATE_HOMEOWNER_INVENTORY_ITEM =
  "UPDATE_HOMEOWNER_INVENTORY_ITEM";
export const GET_INVENTORY_CATEGORY_ITEM_ASYNC =
  "GET_INVENTORY_CATEGORY_ITEM_ASYNC";

export const EXPORT_LOT_LIST = "EXPORT_LOT_LIST";
export const GET_SUBCONTRACTOR_LOT_ID_ASYNC = "GET_SUBCONTRACTOR_LOT_ID_ASYNC";

export const GET_LIST_COST_CODE_SUCCESS = "GET_LIST_COST_CODE_SUCCESS";
export const GET_LIST_COST_CODE_ASYNC = "GET_LIST_COST_CODE_ASYNC";

export const SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC =
  "SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_ASYNC";
export const SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_SUCCESS =
  "SET_ALL_WARRANTY_ACCESS_TO_HOMEOWNER_SUCCESS";

//HOME INVENTORY IN HOMEOWNER

export const GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_ASYNC =
  "GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_ASYNC";
export const GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_SUCCESS =
  "GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_SUCCESS";

export const GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_ASYNC =
  "GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_ASYNC";
export const GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_SUCCESS =
  "GET_LIST_CATEGORY_ITEM_HOME_INVENTORY_HOME_OWNER_SUCCESS";

export const GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_ASYNC =
  "GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_ASYNC";
export const GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_SUCCESS =
  "GET_CATEGORY_ITEM_HOME_INVENTORY_PROFILE_HOME_OWNER_SUCCESS";

export const EDIT_CATEGORY_ITEM_HOMEOWNER_ASYNC =
  "EDIT_CATEGORY_ITEM_HOMEOWNER_ASYNC";

export const GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_ASYNC =
  "GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_ASYNC";
export const GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_SUCCESS =
  "GET_CATEGORY_PROFILE_DETAILS_HOME_OWNER_SUCCESS";

export const GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_ASYNC =
  "GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_ASYNC";
export const GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_SUCCESS =
  "GET_TASK_REMINDER_LIST_FOR_HOMEOWNER_SUCCESS";

export const PATCH_TASK_REMINDER_WITH_ID_ASYNC =
  "PATCH_TASK_REMINDER_WITH_ID_ASYNC";
export const PATCH_TASK_REMINDER_WITH_ID_SUCCESS =
  "PATCH_TASK_REMINDER_WITH_ID_SUCCESS";

export const PATCH_TASK_REMINDER_WITHOUT_ID_ASYNC =
  "PATCH_TASK_REMINDER_WITHOUT_ID_ASYNC";
export const PATCH_TASK_REMINDER_WITHOUT_ID_SUCCESS =
  "PATCH_TASK_REMINDER_WITHOUT_ID_SUCCESS";

export const GET_ITEMS_LIST_BASE_ON_LOTS = "GET_ITEMS_LIST_BASE_ON_LOTS";
export const CREATE_REMINDER = "CREATE_REMINDER";
export const GET_REMINDER_LIST = "GET_REMINDER_LIST";
export const GET_SPECIFIC_REMINDER_DETAILS = "GET_SPECIFIC_REMINDER_DETAILS";
export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const DELETE_REMINDER = "DELETE_REMINDER";
export const ONCHANGE_UPDATE_REMINDER = "ONCHANGE_UPDATE_REMINDER";
export const GET_SPECIFIC_INVENTORY_ID = "GET_SPECIFIC_INVENTORY_ID";
export const UPDATE_INVENTORY_ITEM = "UPDATE_INVENTORY_ITEM";
export const GET_DEFAULT_LOT = "GET_DEFAULT_LOT";
export const POST_DEFAULT_LOT = "POST_DEFAULT_LOT";



// WEBPACK FOOTER //
// ./src/Lots/constants.js